module.exports = __webpack_public_path__ + "img/logo.d9ff2414.png";